import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getImgUrl, limitText } from "../../Utility/Utility";
import { Img } from "../UI/UI";

export const DealItem = (props) => {
  const callToActionText =
    props.callToActionText != undefined ? props.callToActionText : "BOOK NOW";
  const cssClass = props.cssClass != undefined ? props.cssClass : "";
  const link = props.link != undefined ? props.link : "";
  const desc = props.desc != undefined ? props.desc : "";
  const imgArrowWhite =
    props.imgArrowWhite != undefined ? props.imgArrowWhite : "";
  const [isHover, setIsHover] = useState(false);

  return (
    <div
      className="ac-wrapper-deal"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <a href={link} target="_blank" rel="noopener" className={"ac-dael-link"}>
        <h6>{props.agentName}</h6>
        <div className="ac-innerwrapper-deal">
          <Img desktopImg={props.logo} imgCss={"ac-agentlogo"} />
          <p>{limitText(desc, 100)}</p>
          {!isHover ? (
            <span className="ac-inner-link" target="_blank" rel="noopener">
              <span>{callToActionText}</span>{" "}
              <Img desktopImg={imgArrowWhite} imgCss={"ac-arrow"} />
            </span>
          ) : (
            <span
              className="ac-inner-link-hovered"
              target="_blank"
              rel="noopener"
            >
              <span>{callToActionText}</span>{" "}
              <Img desktopImg={imgArrowWhite} imgCss={"ac-arrow"} />
            </span>
          )}
        </div>
      </a>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/Deals/DealItem.js